const template = document.createElement("template");

template.innerHTML = `
<style>
  :host{
    /* Font families */
    --ctl-font-sans: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
    --ctl-font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;

    /* Colors */
    --ctl-text: var(--ctl-color-text);
    --ctl-muted: var(--ctl-color-muted);

    /* Type scale (override globally) */
    --ctl-h1-size: var(--ctl-font-size-xxl, var(--font-size-xxl, 32px));  --ctl-h1-line: var(--ctl-leading-tight, 1.15);  --ctl-h1-weight: var(--ctl-font-weight-bold, 700);     --ctl-h1-letter: var(--ctl-tracking-tight, -0.02em);
    --ctl-h2-size: var(--ctl-font-size-xl, var(--font-size-xl, 28px));    --ctl-h2-line: var(--ctl-leading-tight, 1.18);  --ctl-h2-weight: var(--ctl-font-weight-bold, 700);     --ctl-h2-letter: var(--ctl-tracking-tight, -0.02em);
    --ctl-h3-size: var(--ctl-font-size-lg, var(--font-size-lg, 22px));    --ctl-h3-line: var(--ctl-leading-tight, 1.25);  --ctl-h3-weight: var(--ctl-font-weight-semibold, 650); --ctl-h3-letter: var(--ctl-tracking-tight, -0.015em);
    --ctl-h4-size: var(--ctl-font-size-md, var(--font-size-md, 18px));    --ctl-h4-line: var(--ctl-leading-tight, 1.3);   --ctl-h4-weight: var(--ctl-font-weight-semibold, 650); --ctl-h4-letter: var(--ctl-tracking-tight, -0.01em);
    --ctl-h5-size: var(--ctl-font-size-sm, var(--font-size-sm, 16px));    --ctl-h5-line: var(--ctl-leading-tight, 1.35);  --ctl-h5-weight: var(--ctl-font-weight-semibold, 650); --ctl-h5-letter: var(--ctl-tracking-tight, -0.005em);
    --ctl-h6-size: var(--ctl-font-size-xs, var(--font-size-xs, 14px));    --ctl-h6-line: var(--ctl-leading-normal, 1.4);  --ctl-h6-weight: var(--ctl-font-weight-semibold, 650); --ctl-h6-letter: var(--ctl-tracking-normal, 0em);

    --ctl-body-size: var(--ctl-font-size-base, var(--font-size-sm, 14px));      --ctl-body-line: var(--ctl-leading-normal, 1.55);  --ctl-body-weight: var(--ctl-font-weight-normal, 450);    --ctl-body-letter: var(--ctl-tracking-normal, 0em);
    --ctl-body-sm-size: var(--ctl-font-size-sm, var(--font-size-xs, 13px));     --ctl-body-sm-line: var(--ctl-leading-normal, 1.5);  --ctl-body-sm-weight: var(--ctl-font-weight-normal, 450); --ctl-body-sm-letter: var(--ctl-tracking-normal, 0em);

    --ctl-caption-size: var(--ctl-font-size-sm, var(--font-size-xs, 12px));     --ctl-caption-line: var(--ctl-leading-normal, 1.45);  --ctl-caption-weight: var(--ctl-font-weight-normal, 450);    --ctl-caption-letter: var(--ctl-tracking-normal, 0em);
    --ctl-overline-size: var(--ctl-font-size-xs, var(--font-size-xs, 11px));    --ctl-overline-line: var(--ctl-leading-tight, 1.3);   --ctl-overline-weight: var(--ctl-font-weight-semibold, 650); --ctl-overline-letter: var(--ctl-tracking-widest, 0.08em);

    /* Mono */
    --ctl-mono-size: var(--ctl-font-size-sm, var(--font-size-xs, 13px));   --ctl-mono-line: var(--ctl-leading-normal, 1.5);  --ctl-mono-weight: var(--ctl-font-weight-normal, 450);  --ctl-mono-letter: var(--ctl-tracking-normal, 0em);

    display: inline;
    color: var(--ctl-text);
  }

  /* ensure host doesn't impose block/inline; inner decides */
  .t{
    margin: 0;
    padding: 0;
    color: inherit;
    font-family: var(--ctl-font-sans);
    font-synthesis-weight: none;
  }

  /* Default margins for headings when used alone can be annoying in UI kits.
     Keep them at 0; consumers can add spacing via layout components. */

  /* Variants */
  :host([variant="h1"]) .t{ font-size: var(--ctl-h1-size); line-height: var(--ctl-h1-line); font-weight: var(--ctl-h1-weight); letter-spacing: var(--ctl-h1-letter); }
  :host([variant="h2"]) .t{ font-size: var(--ctl-h2-size); line-height: var(--ctl-h2-line); font-weight: var(--ctl-h2-weight); letter-spacing: var(--ctl-h2-letter); }
  :host([variant="h3"]) .t{ font-size: var(--ctl-h3-size); line-height: var(--ctl-h3-line); font-weight: var(--ctl-h3-weight); letter-spacing: var(--ctl-h3-letter); }
  :host([variant="h4"]) .t{ font-size: var(--ctl-h4-size); line-height: var(--ctl-h4-line); font-weight: var(--ctl-h4-weight); letter-spacing: var(--ctl-h4-letter); }
  :host([variant="h5"]) .t{ font-size: var(--ctl-h5-size); line-height: var(--ctl-h5-line); font-weight: var(--ctl-h5-weight); letter-spacing: var(--ctl-h5-letter); }
  :host([variant="h6"]) .t{ font-size: var(--ctl-h6-size); line-height: var(--ctl-h6-line); font-weight: var(--ctl-h6-weight); letter-spacing: var(--ctl-h6-letter); }

  :host([variant="body"]) .t{ font-size: var(--ctl-body-size); line-height: var(--ctl-body-line); font-weight: var(--ctl-body-weight); letter-spacing: var(--ctl-body-letter); }
  :host([variant="body-sm"]) .t{ font-size: var(--ctl-body-sm-size); line-height: var(--ctl-body-sm-line); font-weight: var(--ctl-body-sm-weight); letter-spacing: var(--ctl-body-sm-letter); }
  :host([variant="caption"]) .t{ font-size: var(--ctl-caption-size); line-height: var(--ctl-caption-line); font-weight: var(--ctl-caption-weight); letter-spacing: var(--ctl-caption-letter); color: var(--ctl-muted); }
  :host([variant="overline"]) .t{ font-size: var(--ctl-overline-size); line-height: var(--ctl-overline-line); font-weight: var(--ctl-overline-weight); letter-spacing: var(--ctl-overline-letter); text-transform: uppercase; color: var(--ctl-muted); }

  :host([variant="mono"]) .t{
    font-family: var(--ctl-font-mono);
    font-size: var(--ctl-mono-size);
    line-height: var(--ctl-mono-line);
    font-weight: var(--ctl-mono-weight);
    letter-spacing: var(--ctl-mono-letter);
  }

  /* Optional modifiers */
  :host([muted]){ color: var(--ctl-muted); }
  :host([nowrap]) .t{ white-space: nowrap; }
  :host([truncate]) .t{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
  }
</style>

<span id="wrap"></span>
`;

const ALLOWED_TAGS = new Set([
  "span", "p", "div", "label",
  "h1", "h2", "h3", "h4", "h5", "h6",
  "small", "strong", "em", "code"
]);

function defaultTagForVariant(variant) {
  if (variant === "h1") return "h1";
  if (variant === "h2") return "h2";
  if (variant === "h3") return "h3";
  if (variant === "h4") return "h4";
  if (variant === "h5") return "h5";
  if (variant === "h6") return "h6";
  if (variant === "caption") return "small";
  if (variant === "overline") return "span";
  if (variant === "mono") return "code";
  // body / body-sm default to span for UI usage; use as="p" if you want paragraphs
  return "span";
}

export class CtlTypography extends HTMLElement {
  static get observedAttributes() {
    return ["variant", "as", "muted", "nowrap", "truncate"];
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(template.content.cloneNode(true));
    this._wrap = this.shadowRoot.getElementById("wrap");
    this._currentTag = null;
  }

  connectedCallback() {
    // Default variant
    if (!this.hasAttribute("variant")) this.setAttribute("variant", "body");
    this._render();
  }

  attributeChangedCallback() {
    this._render();
  }

  _render() {
    const variant = (this.getAttribute("variant") || "body").toLowerCase();
    const asAttr = (this.getAttribute("as") || "").toLowerCase();
    const tag = (asAttr && ALLOWED_TAGS.has(asAttr)) ? asAttr : defaultTagForVariant(variant);

    // Recreate inner element only when tag changes to preserve slot content
    if (!this._el || this._currentTag !== tag) {
      const el = document.createElement(tag);
      el.className = "t";
      el.innerHTML = `<slot></slot>`;
      this._wrap.replaceChildren(el);
      this._el = el;
      this._currentTag = tag;
    }

    // For headings, ensure better semantics if user overrides with non-heading tag:
    // We won't force role, but you can add in future if desired.
  }
}

customElements.define("ctl-typography", CtlTypography);
